import TranslationService from 'services/application/translation/TranslationService';

export default {
	'services.translationService': {
		class: TranslationService,
		deps: [{ $ref: 'services.APIService' }],
	},
};
